import React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsAppFAB from "@/components/WhatsAppFAB";
import ScrollToTop from "@/components/ScrollToTop";

export default function LegalLayout({ eyebrow, title, children, testId }) {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-mrn-bg min-h-screen" data-testid={testId}>
      <Header />
      <main className="pt-32 pb-24">
        <section className="max-w-3xl mx-auto px-6 md:px-10">
          <p className="text-xs uppercase tracking-[0.3em] text-mrn-terracotta font-medium">
            {eyebrow}
          </p>
          <h1 className="mt-4 headline-display text-4xl md:text-6xl text-mrn-wood">
            {title}
          </h1>
          <div className="mt-10 prose-mrn space-y-6 text-mrn-wood-soft text-base md:text-[1.0625rem] leading-relaxed">
            {children}
          </div>
        </section>
      </main>
      <Footer />
      <WhatsAppFAB />
      <ScrollToTop />
    </div>
  );
}
